import { createSelector } from 'reselect'

const customSlideId = state => state.qs.customSlideId

const customSlideIdSelector = createSelector(
	[ customSlideId ],
	customSlideId => customSlideId
)

export default customSlideIdSelector
